import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';
import { BrandLogo } from '@/components/BrandLogo';

export const AppFooter = () => (
  <footer className="border-t border-border py-8 px-6 mt-auto">
    <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
      <BrandLogo width={120} />
      <div className="flex items-center gap-4 text-xs text-muted-foreground">
        <Link to="/terms" className="hover:text-foreground transition-colors duration-150" data-testid="footer-terms-link">Terms of Service</Link>
        <Separator orientation="vertical" className="h-3" />
        <Link to="/tools/coi-requirement-builder" className="hover:text-foreground transition-colors duration-150" data-testid="footer-tools-link">Free Tools</Link>
        <Separator orientation="vertical" className="h-3" />
        <Link to="/privacy" className="hover:text-foreground transition-colors duration-150" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Separator orientation="vertical" className="h-3" />
        <Link to="/support" className="hover:text-foreground transition-colors duration-150" data-testid="footer-support-link">Support</Link>
      </div>
      <p className="text-xs text-muted-foreground">Vendor compliance automation.</p>
    </div>
  </footer>
);
